"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const Schedule_1 = __importDefault(require("@kyruus/react-ikons/Schedule"));
const MiniProviderContent_styles_1 = require("./MiniProviderContent.styles");
const types_1 = require("../types");
const useProviderContent_1 = require("../common/util/useProviderContent");
const constants_1 = require("../common/util/constants");
const ProviderSpecialties_1 = __importDefault(require("./ProviderSpecialties"));
const ProviderName_1 = __importDefault(require("./ProviderName"));
const image_component_1 = require("@kyruus/image-component");
const utils_1 = require("../ProviderSidebar/lib/utils");
/**
 * A component for rendering small, interactive provider cards.
 */
const MiniProviderContent = (0, react_1.forwardRef)(function MiniProviderContentBase(_a, ref) {
    var { provider, availability, location, config = {}, hideFields = [], viewProviderUrl, onViewProvider, viewProviderLinkTarget, compactProviderSpecialties = false, isProfileDisabled = false } = _a, restProps = __rest(_a, ["provider", "availability", "location", "config", "hideFields", "viewProviderUrl", "onViewProvider", "viewProviderLinkTarget", "compactProviderSpecialties", "isProfileDisabled"]);
    const { id, name, availableDaysFromNow, locationName, imageUrl, specialties } = (0, useProviderContent_1.useProviderContent)({
        provider,
        availability,
        location,
        config
    });
    const formattedLocation = location ? (0, utils_1.formatLocation)(location) : '';
    const { config: imageConfig } = (0, image_component_1.useImageService)();
    const StyledImageWrapper = (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.enableEnhancement)
        ? MiniProviderContent_styles_1.ImageWrapperWithEnhancement
        : MiniProviderContent_styles_1.ImageWrapper;
    return (react_1.default.createElement(MiniProviderContent_styles_1.ContentWrapper, Object.assign({}, restProps, { ref: ref, "data-ref": ref ? 'set' : 'unset' }),
        !hideFields.includes(types_1.ShowField.IMAGE) && imageUrl && (react_1.default.createElement(StyledImageWrapper, null,
            react_1.default.createElement(MiniProviderContent_styles_1.ProviderImage, { altText: name, id: `mini-provider-image-${id}`, "data-testid": `mini-provider-image-${id}`, width: 48, height: 48, src: imageUrl, itemProp: "image", "aria-hidden": true, draggable: false, enabledEnhancement: (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.enableEnhancement) || false }))),
        !hideFields.includes(types_1.ShowField.NAME) && name && (react_1.default.createElement(ProviderName_1.default, { provider: provider, viewProviderUrl: viewProviderUrl, onViewProvider: onViewProvider, viewProviderLinkTarget: viewProviderLinkTarget, isProfileDisabled: isProfileDisabled, config: config })),
        !hideFields.includes(types_1.ShowField.SPECIALTY) && specialties != null && (react_1.default.createElement(ProviderSpecialties_1.default, { id: id, compactProviderSpecialties: compactProviderSpecialties, specialties: specialties })),
        location && (react_1.default.createElement(MiniProviderContent_styles_1.StyledLocation, null,
            react_1.default.createElement(MiniProviderContent_styles_1.StyledLocationName, { "data-testid": "provider-address-location-name" }, locationName),
            react_1.default.createElement(MiniProviderContent_styles_1.StyledLocationAddress, { "data-testid": "provider-address-location-address" }, formattedLocation))),
        !(config === null || config === void 0 ? void 0 : config.hide_availability_density) &&
            !hideFields.includes(types_1.ShowField.AVAILABILITY) &&
            availableDaysFromNow != null && (react_1.default.createElement(MiniProviderContent_styles_1.ProviderAvailabilityContainer, { "data-testid": `mini-provider-content-availability-${id}` },
            react_1.default.createElement(Schedule_1.default, { size: "16px", "aria-hidden": true }),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.miniAvailability, { values: { days: availableDaysFromNow } }))))));
});
exports.default = MiniProviderContent;
//# sourceMappingURL=MiniProviderContent.js.map